// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6269":"62d85932","8939":"55e040c9"}[chunkId] + ".chunk.css";
};